module.exports = {"global":{"search":"Buscar...","first":"Primero","previous":"Anterior","next":"Siguiente","last":"Último"},"ticket":{"tickets_list":"Tickets","create_ticket":"Nuevo ticket","added_ticket":"Se ha añadido un nuevo ticket","answer_ticket":"Responder ticket","table":{"for":"PARA","title":"TÍTULO"}}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/es.json
// module id = 748
// module chunks = 3